import { render, staticRenderFns } from "./ParcelItem.vue?vue&type=template&id=32ef0b39&scoped=true"
import script from "./ParcelItem.vue?vue&type=script&lang=ts"
export * from "./ParcelItem.vue?vue&type=script&lang=ts"
import style0 from "./ParcelItem.vue?vue&type=style&index=0&id=32ef0b39&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef0b39",
  null
  
)

export default component.exports